import React from 'react'
import { ExecuteOperationForModelOnPipe } from '@morningtrain/react-resources'
import * as Auth from '@morningtrain/react-auth'
import { Translation } from '@morningtrain/react-translations'
import * as UI from 'ui'
import ShiftExchangeRefreshPipes from 'support/actions/shifts/ShiftExchangeRefreshPipes'
import ConfirmOnClickPipeline from 'support/pipelines/ConfirmOnClickPipeline'

export default function RejectShiftExchange ({ slotId }) {
  return (
    <Auth.CanUseModel permission='api.shifts.exchange.reject'>
      <ConfirmOnClickPipeline trigger={(
        <UI.Button>
          <Translation name='shiftexchange.actions.decline' />
        </UI.Button>
      )}
      >
        <ExecuteOperationForModelOnPipe resourceName='shifts.exchange' operationName='reject' />
        <ShiftExchangeRefreshPipes slotId={slotId} />
      </ConfirmOnClickPipeline>
    </Auth.CanUseModel>
  )
}
